<template>
  <p v-if="temporary" class="no-margin">
    <span v-if="temporary.type === 'load'">
      {{ $t('temporary.load', {current: Math.max(temporary.current - 1, 0), max: temporary.max}) }}
    </span>
    <span v-if="temporary.type === 'until'">
      {{ $t('temporary.until', {date: $moment(temporary.value).format('DD-MM-YYYY HH:mm')}) }}
    </span>
  </p>
</template>

<script>
    export default {
        name: 'TemporaryText',
        props: {
            temporary: Object,
        },
    };
</script>

<style>
</style>
